var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "cvdownload no-border", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-header",
        {
          staticClass:
            "border-bottom-0 headline-very-small text-uppercase font-weight-bold text-brand-dark pb-0",
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [_vm._v(_vm._s(_vm.t.CV_Tool_Download_Title))]
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("ArrowNavigation", {
                        attrs: { backOnly: true },
                        on: {
                          click: function ($event) {
                            return _vm.changeSection($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-body",
        [
          _c("b-card-title", { staticClass: "h5" }, [
            _vm._v(_vm._s(_vm.t.CV_Tool_Download_Title_Body)),
          ]),
          _c("b-card-text", {
            staticClass: "text-muted",
            domProps: { innerHTML: _vm._s(_vm.t.CV_Tool_Download_Description) },
          }),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column align-items-center",
              class: this.coverLetterId !== 0 ? "mt-4" : "mt-5",
            },
            [
              _c("b-card-text", {
                staticClass: "text-small text-muted",
                domProps: {
                  innerHTML: _vm._s(_vm.t.CV_Tool_Download_CV_Download),
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex align-items-center mb-4" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "d-flex justify-content-center cv-download mx-3 py-1",
                      on: {
                        click: function ($event) {
                          return _vm.downloadCV(false)
                        },
                      },
                    },
                    [
                      _c(
                        "BaseIcon",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 1024 1024",
                          },
                        },
                        [_c("WordFile")],
                        1
                      ),
                      _c("div", { staticClass: "font-weight-light ml-2" }, [
                        _vm._v("Word"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "d-flex justify-content-center cv-download mx-3 py-1",
                      on: {
                        click: function ($event) {
                          return _vm.downloadCV(true)
                        },
                      },
                    },
                    [
                      _c(
                        "BaseIcon",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 1024 1024",
                          },
                        },
                        [_c("PDFFile")],
                        1
                      ),
                      _c("div", { staticClass: "font-weight-light ml-2" }, [
                        _vm._v("PDF"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-card-text", {
                staticClass: "text-small text-muted",
                domProps: { innerHTML: _vm._s(_vm.t.CV_Tool_Download_CV_Save) },
              }),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "d-flex justify-content-center cv-download mx-3 py-1",
                      on: {
                        click: function ($event) {
                          return _vm.saveInDocuments(false)
                        },
                      },
                    },
                    [
                      _c(
                        "BaseIcon",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 1024 1024",
                          },
                        },
                        [_c("WordFile")],
                        1
                      ),
                      _c("div", { staticClass: "font-weight-light ml-2" }, [
                        _vm._v("Word"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "d-flex justify-content-center cv-download mx-3 py-1",
                      on: {
                        click: function ($event) {
                          return _vm.saveInDocuments(true)
                        },
                      },
                    },
                    [
                      _c(
                        "BaseIcon",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 1024 1024",
                          },
                        },
                        [_c("PDFFile")],
                        1
                      ),
                      _c("div", { staticClass: "font-weight-light ml-2" }, [
                        _vm._v("PDF"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.savingToDocuments === true
                ? _c(
                    "b-card-text",
                    { staticClass: "mt-1" },
                    [
                      _vm.savingToDocuments === true
                        ? [
                            _c("b-spinner", {
                              attrs: { small: "", variant: "primary" },
                            }),
                            _c(
                              "span",
                              { staticClass: "ml-1 text-brand-light" },
                              [_vm._v(_vm._s(_vm.t.CV_Tool_Download_Saving))]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.savingToDocuments === false && _vm.savedToDocuments === true
                ? _c(
                    "div",
                    { staticClass: "dropdown-header d-flex text-nowrap" },
                    [
                      _c("div", {
                        staticClass: "text-muted mr-2",
                        domProps: {
                          textContent: _vm._s(_vm.t.CV_Tool_Download_Saved),
                        },
                      }),
                      _vm.linkToDocuments !== undefined
                        ? _c(
                            "b-link",
                            {
                              key: "documentsLink",
                              attrs: { href: _vm.linkToDocuments },
                            },
                            [
                              _c("span", {
                                staticClass: "text-brand-light mb-1",
                                domProps: {
                                  innerHTML: _vm._s(_vm.documentsLinkName),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              this.coverLetterId !== 0
                ? [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column mt-5" },
                      [
                        _c("b-card-title", { staticClass: "h5 mt-5" }, [
                          _vm._v(
                            _vm._s(_vm.t.CV_Tool_Cover_Letter_Available_Title)
                          ),
                        ]),
                        _c("b-card-text", {
                          staticClass: "text-muted",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.t.CV_Tool_Cover_Letter_Available_Text
                            ),
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center",
                          },
                          [
                            _c("b-card-text", {
                              staticClass: "text-small text-muted",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.t.CV_Tool_Download_CL_Download
                                ),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-4" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadCoverLetter()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("WordFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("Word")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("b-card-text", {
                              staticClass: "text-small text-muted",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.t.CV_Tool_Download_CL_Save
                                ),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveCoverLetterInDocuments()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("WordFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("Word")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.savingCoverLetterToDocuments === true
                      ? _c(
                          "b-card-text",
                          { staticClass: "mt-1" },
                          [
                            _vm.savingCoverLetterToDocuments === true
                              ? [
                                  _c("b-spinner", {
                                    attrs: { small: "", variant: "primary" },
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "ml-1 text-brand-light" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.t.CV_Tool_Download_Saving)
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.savingCoverLetterToDocuments === false &&
                    _vm.savedCoverLetterToDocuments === true
                      ? _c(
                          "div",
                          { staticClass: "dropdown-header d-flex text-nowrap" },
                          [
                            _c("div", {
                              staticClass: "text-muted mr-2",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.t.CV_Tool_Cover_Letter_Download_Saved
                                ),
                              },
                            }),
                            _vm.linkToDocuments !== undefined
                              ? _c(
                                  "b-link",
                                  {
                                    key: "documentsLink",
                                    attrs: { href: _vm.linkToDocuments },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "text-brand-light mb-1",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.documentsLinkName
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "b-row",
            { staticClass: "text-center mb-2 mt-5" },
            [
              _c(
                "b-col",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2",
                      attrs: { variant: "link" },
                      on: { click: _vm.clearSelection },
                    },
                    [_vm._v(_vm._s(_vm.t.CV_Tool_Cancel))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }